type DragListener = (isDragging: boolean) => void;
const listeners = new Set<DragListener>();

let currentDragging = false;

export const setGlobalDragging = (isDragging: boolean): void => {
    if (currentDragging !== isDragging) {
        currentDragging = isDragging;
        listeners.forEach((listener) => {
            try {
                listener(isDragging);
            } catch (err) {
                console.error("Error in drag listener", err);
            }
        });
    }
};

export const subscribeToGlobalDragging = (listener: DragListener): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export const getGlobalDragging = (): boolean => currentDragging;
